    <div class="page-shell">
      <nav class="app-nav" [class.app-nav-open]="isMenuOpen()">
        <div class="nav-inner">
          <a class="brand-mark" routerLink="/dashboard" aria-label="Central Profile" (click)="closeMenu()">
            <img src="/rectangular%20logo.PNG" alt="Central Profile" />
          </a>

          <button
            class="nav-toggle"
            type="button"
            [attr.aria-expanded]="isMenuOpen()"
            aria-label="Toggle navigation menu"
            (click)="toggleMenu()"
          >
            <i class="fa-solid" [class.fa-bars]="!isMenuOpen()" [class.fa-xmark]="isMenuOpen()"></i>
          </button>

          <button
            class="nav-backdrop"
            type="button"
            tabindex="-1"
            aria-label="Close navigation menu"
            (click)="closeMenu()"
          ></button>

          <div class="nav-drawer">
            <div class="nav-links">
              <a class="nav-link" routerLink="/dashboard" routerLinkActive="active" (click)="closeMenu()">Home</a>
              <a class="nav-link" routerLink="/about" routerLinkActive="active" (click)="closeMenu()">About</a>
              <a class="nav-link" routerLink="/contact" routerLinkActive="active" (click)="closeMenu()">Contact</a>
            </div>

            <div class="nav-actions">
              <button class="btn btn-outline" type="button" (click)="logout()">Logout</button>
            </div>
          </div>
        </div>
      </nav>

        <app-breadcrumb></app-breadcrumb>

      <main class="main-content">
        <div class="content-wrap">
          <router-outlet></router-outlet>
        </div>
      </main>

      <footer class="footer">
        Copyright {{ currentYear }} T Tutoring Agency Pty Ltd
      </footer>
    </div>
